<!--
 * @FileDescription: 已弃用
 * @Author: 陈文景
 * @Date: 2023-02-24 15:39:48
 * @LastEditors: 最后更新作者
 * @LastEditTime: 最后更新时间
-->
<template>
  <div class="deprecates-box">
    <BatchSearchOne @clear="handleClearBatchSearchOne" @search="handleSearchBatchSearchOne" />

    <el-table v-loading="loading" :data="deprecates" row-key="id" size="medium" border stripe style="width: 100%" height="100%">
      <el-table-column type="index" align="center" label="序号" width="80" />
      <el-table-column prop="term" align="center" label="热搜词" />
      <el-table-column align="center" label="状态">
        <template v-slot="{ row }">
          {{ row.status === 0 ? '弃用' : '启用' }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="生效时间">
        <template v-slot="{ row }">
          {{ formatTimeStamp(row.createDate) }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="失效时间">
        <template v-slot="{ row }">
          {{ formatTimeStamp(row.modifyDate) }}
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="100">
        <template v-slot="{ row }">
          <el-button type="text" size="medium" @click="() => onActivate(row)">启用</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="footer">
      <el-pagination background :page-sizes="[20, 30, 40, 50]" layout="total, sizes, prev, pager, next, jumper" :total="total" :current-page="parameter.pageNumber" @size-change="sizeChange" @current-change="currentChange" />
    </div>
  </div>
</template>

<script>
import API from '@/api'
import BatchSearchOne from './BatchSearchOne.vue'
import { formatTimeStamp } from '@/utils/moment.js'

let parameter = {
  type: 2, // 1.启用 2.弃用
  terms: [], // 批量搜索词
  pageSize: 20,
  pageNumber: 1
}

export default {
  components: {
    BatchSearchOne
  },
  data() {
    return {
      formatTimeStamp,

      parameter: { ...parameter }, // 获取已弃用列表的请求参数

      deprecates: [], // 已弃用搜索词列表
      total: 0, // 总数量
      loading: false // 表格Loading
    }
  },
  methods: {
    /**
     * API 获取已弃用热搜词列表
     *
     * @param {Boolean} reset 是否重置分页
     */
    async getHotsearchList(reset = true) {
      try {
        if (reset) {
          this.parameter.pageNumber = 1
        }
        this.loading = true
        let { data } = await API.getHotsearchList(this.parameter)
        this.total = data.total
        this.deprecates = data.list
        this.loading = false
      } catch (error) {
        this.loading = false
      }
    },

    /**
     * API 修改热搜词状态
     *
     * @param {Object} parameter 请求参数: {id: '', status: ''}
     */
    async editHotsearchWordsStatus(parameter) {
      let { code, message } = await API.editHotsearchWordsStatus(parameter)
      if (code === 10000) {
        this.getHotsearchList(false)
        this.$message.success(message)
      } else {
        this.$message.error(message)
      }
    },

    /**
     * 批量搜索清除内容的回调事件
     */
    handleClearBatchSearchOne() {
      this.parameter.terms = []
      this.getHotsearchList()
    },

    /**
     * 批量搜索的回调事件
     *
     * @param {String} value 搜索关键字数组
     */
    handleSearchBatchSearchOne(value) {
      this.parameter.terms = [...value]
      this.getHotsearchList()
    },

    /**
     * 启用按钮的回调事件
     *
     * @param {Object} row 当前点击的行数据
     */
    onActivate(row) {
      this.$confirm('此操作将启用该热搜词, 是否继续?', '提示', {
        confirmButtonText: '启用',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.editHotsearchWordsStatus({ id: row.id, status: 1 })
        })
        .catch(() => {
          this.$message.info('已取消操作')
        })
    },

    /**
     * 每页显示条数发生改变时的回调
     *
     * @param {Number} size 每页显示条数
     */
    sizeChange(size) {
      this.parameter.pageSize = size
      this.getHotsearchList(false)
    },

    /**
     * 上一页/下一页/当前页发生改变时的回调
     *
     * @param {Number} current 当前页
     */
    currentChange(current) {
      this.parameter.pageNumber = current
      this.getHotsearchList(false)
    }
  }
}
</script>

<style lang="scss" scoped>
.deprecates-box {
  height: calc(100% - 98px);
  .el-table {
    margin-top: 15px;
  }

  .footer {
    text-align: end;
    margin-top: 15px;
  }
}
</style>
